import React from 'react';
import { Chip } from '@mui/material';
import {
  Edit as PlanningIcon,
  PlayArrow as ActiveIcon,
  Pause as OnHoldIcon,
  CheckCircle as CompletedIcon,
  Cancel as CancelledIcon,
} from '@mui/icons-material';
import type { ProjectStatus } from '../../types/project';
import { PROJECT_STATUS_OPTIONS } from '../../types/project';

interface ProjectStatusBadgeProps {
  status: ProjectStatus;
  size?: 'small' | 'medium';
  showIcon?: boolean;
  onClick?: () => void;
}

const statusIcons: Record<ProjectStatus, React.ReactNode> = {
  planning: <PlanningIcon fontSize="small" />,
  active: <ActiveIcon fontSize="small" />,
  on_hold: <OnHoldIcon fontSize="small" />,
  completed: <CompletedIcon fontSize="small" />,
  cancelled: <CancelledIcon fontSize="small" />,
};

export const ProjectStatusBadge: React.FC<ProjectStatusBadgeProps> = ({
  status,
  size = 'small',
  showIcon = true,
  onClick,
}) => {
  const statusOption = PROJECT_STATUS_OPTIONS.find((s) => s.value === status);

  if (!statusOption) {
    return null;
  }

  return (
    <Chip
      label={statusOption.label}
      size={size}
      icon={showIcon ? statusIcons[status] as React.ReactElement : undefined}
      onClick={onClick}
      sx={{
        backgroundColor: statusOption.bgColor,
        color: statusOption.color,
        fontWeight: 500,
        cursor: onClick ? 'pointer' : 'default',
        '& .MuiChip-icon': {
          color: statusOption.color,
        },
      }}
    />
  );
};

export default ProjectStatusBadge;
